import { render, staticRenderFns } from "./goods-zoom.vue?vue&type=template&id=20e429c3&scoped=true&"
import script from "./goods-zoom.vue?vue&type=script&lang=js&"
export * from "./goods-zoom.vue?vue&type=script&lang=js&"
import style0 from "./goods-zoom.vue?vue&type=style&index=0&id=20e429c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e429c3",
  null
  
)

export default component.exports